import { type PurchaseState } from '../../../apiRtk/be4feMy2nApi';
import { TERMINAL_PURCHASE_STATES } from '../constants';

export function isTerminalPurchaseState(state?: PurchaseState | null): boolean {
  return !!state && TERMINAL_PURCHASE_STATES.has(state);
}
